import React, { createContext, useState } from "react";
import { INotification, INotificationsContext } from "../types/notifications";

export const NotificationsContext = createContext<null | INotificationsContext>(null);

interface Props {
    children: React.ReactNode
}

export const NotificationsProvider: React.FC<Props> = ({ children }) => {    
    const [notificationsToRead, setNotificationsToRead] = useState<INotification[]>([]);    

    const value: INotificationsContext = {
       notificationsToRead,
       setNotificationsToRead
    };

    return (
        <NotificationsContext.Provider
            value={value}
        >
            {children}
        </NotificationsContext.Provider>
    );
};